import * as React from 'react'
import { forwardRef, useEffect } from 'react'

import MenuItem from '@material-ui/core/MenuItem'
import ExitIcon from '@material-ui/icons/PowerSettingsNew'
import { LOGOUT_URL_WITH_REDIRECT } from 'configs/auth'
import { useLogout } from 'react-admin'

import tracker from '../../utils/tracker'

export default forwardRef((props, ref) => {
  const logout = useLogout()
  const handleClick = async () => {
    await logout()
    window.location.href = LOGOUT_URL_WITH_REDIRECT
  }

  useEffect(() => {
    tracker.event({
      action: 'top_bar_menu_clicked',
      category: 'topBar',
    })
  })

  return (
    <MenuItem onClick={handleClick} ref={ref}>
      <ExitIcon /> Logout
    </MenuItem>
  )
})
